<template>
  <validation-observer v-slot="{ invalid }">
    <ui-modal
      :validated="false"
      :closable="false"
      @confirm="sendForm"
      @hidden="$emit('cancel')"
    >
      <div class="header">
        {{ $t("header") }}
      </div>

      <div class="content">
        <div class="ui form">
          <div class="field">
            <label>{{ $t("labels.email") | cap }}</label>
            <ValidationProvider
              name="email"
              rules="required|email"
              v-slot="{ errors }"
            >
              <input
                v-model.trim="feedback.email"
                type="email"
                placeholder="my@email.com"
                required
              />
              <div :class="$style.error">
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </div>

          <div class="field">
            <label>{{ $t("labels.subject") | cap }}</label>
            <ValidationProvider
              name="subject"
              rules="required"
              v-slot="{ errors }"
            >
              <input
                v-model.trim="feedback.subject"
                type="text"
                :placeholder="$t('placeholder.subject')"
                required
              />
              <div :class="$style.error">
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </div>

          <div class="field">
            <label>{{ $t("labels.content") | cap }}</label>
            <ValidationProvider
              name="text"
              rules="required|max:1000"
              v-slot="{ errors }"
            >
              <textarea
                ref="textarea"
                v-model.trim="feedback.text"
                rows="5"
                :class="$style.textarea"
                :placeholder="$t('placeholder.text')"
              />
              <div :class="$style.error">
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </div>
        </div>
      </div>

      <div class="actions">
        <button class="ui deny button" :class="{ disabled: pending }">
          {{ $t("buttons.cancel") | cap }}
        </button>
        <button
          class="ui positive right labeled icon button"
          :class="{ loading: pending, disabled: pending || invalid }"
        >
          {{ $t("buttons.send") | cap }}
          <i class="checkmark icon" />
        </button>
      </div>
    </ui-modal>
  </validation-observer>
</template>

<script>
import UiModal from '@/components/UiModal.vue'
import { mapGetters } from 'vuex'
import * as R from 'ramda'
import api from '@/libs/api'
import autosize from 'autosize'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: {
    UiModal,
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      feedback: {
        email: '',
        subject: '',
        text: ''
      },
      pending: false
    }
  },
  methods: {
    async sendForm ($modal) {
      this.$fa.logEvent(this.$fa.Event.FEEDBACK)

      this.pending = true

      try {
        await api
          .sendFeedback()
          .send(Object.assign(this.feedback, this.metadata))
        this.$noty(this.$ntype.SENT)
        $modal.modal('hide')
      } catch (e) {
        this.$notyError(e)
      } finally {
        this.pending = false
      }
    }
  },
  computed: {
    ...mapGetters(['user']),
    metadata () {
      return {
        appVersion: process.env.appVersion,
        platform: this.$store.getters.platform,
        uid: this.user && this.user.uid,
        model: device.model,
        deviceVersion: device.version,
        deviceManufacturer: device.manufacturer
      }
    },
    userEmail () {
      return this.user ? this.user.email : ''
    }
  },
  created () {
    if (!R.isEmpty(this.userEmail)) {
      this.feedback.email = this.userEmail
    }
  },
  mounted () {
    autosize(this.$refs.textarea)
  },
  beforeDestroy () {
    autosize.destroy(this.$refs.textarea)
  },
  i18n: {
    messages: {
      ko: {
        header: '피드백 보내기',
        labels: {
          subject: '제목',
          content: '내용'
        },
        placeholder: {
          subject: '제목을 입력해주세요',
          text: '문의사항, 개선점, 버그, 에러 등등'
        },
        buttons: {
          send: '보내기'
        }
      },
      en: {
        header: 'Send feedback',
        labels: {
          subject: 'subject',
          content: 'content'
        },
        placeholder: {
          subject: 'Please enter a subject',
          text: 'questions, improvements, bugs, errors, etc.'
        },
        buttons: {
          send: 'send'
        }
      }
    }
  }
}
</script>

<style module>
.error {
  margin-top: 4px;
  font-size: 0.85rem;
  color: #b03060;
}

.textarea {
  max-height: 250px;
}
</style>
